export default "__VITE_ASSET__9b440472__"